"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const lodash_1 = require("lodash");
const webpack = require("webpack");
const urbanjs_tools_core_1 = require("urbanjs-tools-core");
const defaults_1 = require("./defaults");
let Webpack = class Webpack {
    constructor(configService, taskService, loggerService, fsService, traceService) {
        this.loggerService = loggerService;
        this.configService = configService;
        this.taskService = taskService;
        this.fsService = fsService;
        traceService.track(this);
    }
    register(taskName, parameters) {
        this.taskService.addTask(taskName, [], () => __awaiter(this, void 0, void 0, function* () {
            this.loggerService.debug('running task', taskName);
            try {
                const defaults = defaults_1.getDefaults(this.configService.getGlobalConfiguration());
                const config = this.configService.mergeParameters(defaults, parameters, taskName);
                if (config.clean) {
                    yield Promise.all([].concat(config).map(itemConfig => this.fsService.remove(itemConfig.output.path)));
                }
                yield new Promise((resolve, reject) => {
                    webpack([].concat(config).map(itemConfig => lodash_1.omit(itemConfig, 'clean'))).run((err, stats) => {
                        this.logStats(stats);
                        if (err) {
                            reject(err);
                            return;
                        }
                        resolve();
                    });
                });
            }
            catch (e) {
                this.loggerService.error(`Unexpected error in ${taskName}`, e);
                throw e;
            }
        }));
        const watchTaskName = `${taskName}:watch`;
        this.taskService.addTask(watchTaskName, [], () => __awaiter(this, void 0, void 0, function* () {
            this.loggerService.debug('running task', watchTaskName);
            try {
                const defaults = defaults_1.getDefaults(this.configService.getGlobalConfiguration());
                const config = this.configService.mergeParameters(defaults, parameters, taskName);
                if (config.clean) {
                    yield Promise.all([].concat(config).map(itemConfig => this.fsService.remove(itemConfig.output.path)));
                }
                yield new Promise(() => {
                    webpack([].concat(config).map(itemConfig => lodash_1.omit(itemConfig, 'clean'))).watch({ poll: 200 }, (err, stats) => {
                        this.logStats(stats);
                        if (err) {
                            this.loggerService.error(err);
                            return;
                        }
                    });
                });
            }
            catch (e) {
                this.loggerService.error(`Unexpected error in ${taskName}`, e);
                throw e;
            }
        }));
    }
    logStats(stats) {
        if (stats) {
            const statsJson = stats.toJson();
            const errors = statsJson.errors.concat(statsJson.warnings);
            if (errors.length) {
                this.loggerService.error('Failed compiling', errors.join(''));
            }
            else {
                this.loggerService.info('Successful compiling');
            }
        }
    }
};
__decorate([
    urbanjs_tools_core_1.track(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], Webpack.prototype, "register", null);
Webpack = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_CONFIG)),
    __param(1, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_TASK)),
    __param(2, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_LOGGER)),
    __param(3, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_FILE_SYSTEM)),
    __param(4, inversify_1.inject(urbanjs_tools_core_1.TYPE_SERVICE_TRACE)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object])
], Webpack);
exports.Webpack = Webpack;
